import React from 'react';
import { LoadingPage } from '@pageComponents/LoadingPage';

const LoggingIn: React.FC = () => <LoadingPage message={'Logging in...'} />;

export default LoggingIn;
